import * as yup from 'yup'

export const GET_DEV_PLAN =
  'pages/coach/userManagement/singleUser/developmentPlan/getDevPlan'

export const GET_DEV_STATS =
  'pages/coach/userManagement/singleUser/developmentPlan/getDevChart'

export const goalSchema = yup.object().shape({
  title: yup
    .string()
    .required('Please enter goal title')
    .max(
      150,
      'Entry is above character maximum, please reduce the length before saving'
    )
})

export const chartYTickValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

// The API accepts 1000 characters for an action step description, and the
// column is varchar(1000). This was three separate hard-coded 295s across two
// components, which is why raising the API limit changed nothing on its own --
// the form refused the entry before it was ever sent. One constant, so the next
// change is one edit.
export const ACTION_STEP_MAX_LENGTH = 1000
